// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "hash": "8106eb5e",
    "fullHash": "8106eb5eda4d6421370f39b65e984758e0a32cb2",
    "branch": "HEAD",
    "tag": "R-25-3.1"
};
/* tslint:enable */
